function fn_layout_main() {
    var reInitGCaptcha;
    var $body = $("body");
    
    reInitGCaptcha = function() {
        $.getScript("https://www.google.com/recaptcha/api.js?render=6LfbDMIUAAAAALWjS_5TqQLL9QBupmnlfh1ELNMG").done(function () {
            grecaptcha.ready(function () {
                grecaptcha.execute('6LfbDMIUAAAAALWjS_5TqQLL9QBupmnlfh1ELNMG', {action: 'form'})
                    .then(function (token) {
                        $('#g-token').val(token);
                    });
            });
        });
    };
    
    if ($('form[data-recaptcha]').length) {
        reInitGCaptcha();
    }

    setTimeout(function () {
        $body.removeClass("preload").addClass("loaded");
        $(document).trigger("bodyLoaded");

        setTimeout(function () {
            $body.removeClass("loaded");

            $(document).on('click', '[data-scroll]', function (event) {
                event.preventDefault();

                var anchor = $(this).attr('data-scroll');

                $('html,body').animate({
                    scrollTop: $('#'+anchor).offset().top

                }, 500);
            });
        }, 500);
    }, 300);
}

$("#language-select-button").click(function () {
    $("#other-languages").slideToggle();
    if ($(this).hasClass("isOpen")) {
        $(this).removeClass("isOpen");
        $(this).find(".more-arrow").removeClass("arrow-open");
    } else {
        $(this).addClass("isOpen");
        $(this).find(".more-arrow").addClass("arrow-open");
    }
});

if ($(document).width() > 1024) {
    $('select').select2({
        minimumResultsForSearch: -1
    });
}


$('#main-slider').slick({
    arrows: true,
    dots: false,
    infinite: true,
    speed: 300,
    fade: true,
    cssEase: 'linear',
    autoplay: true,
    autoplaySpeed: 4000,
    prevArrow: "<button type='button' class='slick-prev icon-chevron-thin-left'></button>",
    nextArrow: "<button type='button' class='slick-next icon-chevron-thin-right'></button>",
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
});

$('.team_slider').slick({
    arrows: true,
    dots: false,
    infinite: false,
    speed: 300,
    cssEase: 'linear',
    slidesToShow: 3,
    prevArrow: "<button type='button' class='slick-prev icon-chevron-thin-left'></button>",
    nextArrow: "<button type='button' class='slick-next icon-chevron-thin-right'></button>",
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 360,
            settings: {
                slidesToShow: 1
            }
        }
    ]
});


$(".book-dropdown-button").click(function (e) {
    e.preventDefault();

    return false;
});

/*
 $('#bg-slider').slick({
 arrows: false,
 dots: false,
 infinite: true,
 speed: 300,
 fade: true,
 cssEase: 'linear',
 // You can unslick at a given breakpoint now by adding:
 // settings: "unslick"
 // instead of a settings object
 });
 */


//Smooth scrolling

$(function () {
    $('a[href*="#"]:not([href="#"])').click(function () {
        console.log("scrolling...");
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 1000);
                return false;
            }
        }
    });
});

// tag body with special class just for edge browser

$(function () {
    if (/Edge\/\d./i.test(navigator.userAgent)) {
        $('body').addClass('edge-browser')
    }
});


//Previo

function showPrevio() {
    $(".previo-overlay").fadeIn();
    var previo = $(".previo");

    previo.fadeIn();
    previo.css({"top": $(window).scrollTop()});

}

function hidePrevio() {
    $(".previo").fadeOut();
    $(".previo-overlay").fadeOut();
    $("body").css({"overflow": 'scroll'});
}


$(".js-previo").click(function (e) {
    e.preventDefault();

    var hotel = $(this).data('booking-hotel');
    var langHotel = $(this).data('lang');
    if (hotel !== null) {
        var script = null;
        if(hotel == "athanor"){
            script = "<script type='text/javascript' src='https://booking.previo.cz/iframe/'></script> <p><iframe id='previo-booking-iframe' src='https://booking.previo.cz/?hotId=1994&pricesPerOccupancy&theme=theme01&lang="+langHotel+"' name='previo-booking-iframe' width='750' height='2500' frameborder='0' scrolling='no' allowtransparency='true'></iframe></p> ";
        }
        if(hotel == "chornitz"){
            script = "<script type='text/javascript' src='https://booking.previo.cz/iframe/'></script> <p><iframe id='previo-booking-iframe' src='https://booking.previo.cz/?hotId=28478&pricesPerOccupancy&theme=grey&lang="+langHotel+"' name='previo-booking-iframe' width='750' height='2500' frameborder='0' scrolling='no' allowtransparency='true'></iframe></p>";
        }
        if(hotel == "baltazar"){
            script = "<script type='text/javascript' src='https://booking.previo.cz/iframe/'></script><p><iframe id='previo-booking-iframe' src='https://booking.previo.cz/?hotId=27632&pricesPerOccupancy&theme=orange&lang="+langHotel+"' name='previo-booking-iframe' width='750' height='2500' frameborder='0' scrolling='no' allowtransparency='true'></iframe></p> ";
        }
        if(hotel == "adalbert"){
            script = "<script type='text/javascript' src='https://booking.previo.cz/iframe/'></script><p><iframe id='previo-booking-iframe' src='https://booking.previo.cz/?hotId=735434&pricesPerOccupancy&theme=orange&lang="+langHotel+"' name='previo-booking-iframe' width='750' height='2500' frameborder='0' scrolling='no' allowtransparency='true'></iframe></p> ";
        }
        $("#content-iframes-at-landing-page").html(script);
        
    }

    showPrevio();

    return false;
});


$(".previo-overlay, .js-previo-close").click(function () {
    hidePrevio();
});

//Click on first element in free time to display content.
if ($("#data-first-click").length) {
    setTimeout(function () {
        $("#data-first-click").trigger("click");
    }, 10);

}


